import React from "react";
import { Row, Col, Typography, Divider } from "antd";
import {
  MessageOutlined,
  SearchOutlined,
  BgColorsOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import Reveal from "../common/Reveal";

const { Title, Paragraph } = Typography;

const steps = [
  {
    number: "1",
    title: "Envie sua necessidade",
    description:
      "Informe o tipo de peça, acabamento desejado e volume aproximado para análise.",
    icon: <MessageOutlined />,
    shortLabel: "Solicitação",
  },
  {
    number: "2",
    title: "Análise técnica",
    description:
      "Nossa equipe avalia o serviço ideal para garantir brilho, padrão visual e qualidade.",
    icon: <SearchOutlined />,
    shortLabel: "Avaliação",
  },
  {
    number: "3",
    title: "Processo de banho",
    description:
      "Executamos o Banho de Ouro com controle técnico e atenção a cada detalhe da peça.",
    icon: <BgColorsOutlined />,
    shortLabel: "Produção",
  },
  {
    number: "4",
    title: "Controle e entrega",
    description:
      "As peças passam por conferência final antes da entrega, garantindo mais segurança no resultado.",
    icon: <CheckCircleOutlined />,
    shortLabel: "Entrega",
  },
];

function ComoFunciona() {
  return (
    <section
      style={{
        padding: "88px 24px",
        background: "#f8f6f2",
      }}
    >
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        {/* HEADER */}
        <Reveal>
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <Title
              level={2}
              style={{
                marginBottom: 12,
                color: "#1f1f1f",
              }}
            >
              Como funciona o Banho de Ouro para Semijoias e Bijuterias.
            </Title>

            <Paragraph
              style={{
                maxWidth: 760,
                margin: "0 auto",
                fontSize: 16,
                color: "#666",
              }}
            >
              Um processo organizado para garantir acabamento premium, brilho
              uniforme e mais confiança em cada etapa.
            </Paragraph>
          </div>
        </Reveal>

        {/* CARDS */}
        <Row gutter={[24, 32]} justify="center">
          {steps.map((step, index) => (
            <Col xs={24} sm={12} lg={6} key={step.number}>
              <Reveal delay={200 * (index + 1)} y={24}>
                <div
                  style={{
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: 22,
                      padding: "28px 22px",
                      minHeight: 270,
                      boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
                      border: "1px solid rgba(212, 180, 131, 0.18)",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          width: 84,
                          height: 84,
                          margin: "0 auto 20px",
                          borderRadius: 20,
                          background:
                            "linear-gradient(135deg, #d4b483, #b8925f)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 34,
                          color: "#fff",
                          boxShadow: "0 8px 20px rgba(184,146,95,0.22)",
                        }}
                      >
                        {step.icon}
                      </div>

                      <Title
                        level={4}
                        style={{
                          marginBottom: 12,
                          fontSize: 22,
                          color: "#1f1f1f",
                        }}
                      >
                        {step.title}
                      </Title>

                      <Paragraph
                        style={{
                          marginBottom: 0,
                          color: "#666",
                          fontSize: 15,
                          lineHeight: 1.6,
                        }}
                      >
                        {step.description}
                      </Paragraph>
                    </div>
                  </div>
                </div>
              </Reveal>
            </Col>
          ))}
        </Row>

        {/* TIMELINE */}
        <div
          style={{
            marginTop: 42,
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 18,
              left: 0,
              right: 0,
              height: 4,
              background: "rgba(212, 180, 131, 0.35)",
              borderRadius: 999,
            }}
          />

          <Row gutter={[24, 16]} justify="center">
            {steps.map((step, index) => (
              <Col xs={6} sm={6} lg={6} key={step.number}>
                <Reveal delay={200 * (index + 1)}>
                  <div
                    style={{
                      textAlign: "center",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        margin: "0 auto 10px",
                        background: "#111",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 18,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "4px solid #f8f6f2",
                        position: "relative",
                        zIndex: 2,
                      }}
                    >
                      {step.number}
                    </div>

                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: 600,
                        color: "#4b4b4b",
                      }}
                    >
                      {step.shortLabel}
                    </div>
                  </div>
                </Reveal>
              </Col>
            ))}
          </Row>
        </div>
      </div>
      <Divider style={{marginTop: 150}}></Divider>
    </section>
  );
}

export default ComoFunciona;